import { graphql, type ResultOf } from "@/data-access/graphql";
import { SavedViewFragment } from "../fragments/saved-views-fragments";

export const GetSavedViews = graphql(
  `
    query getSavedViews($filters: FeedSavedViewTypeFilter) {
      feedSavedViews(filters: $filters) {
        ...SavedViewFragment
      }
    }
  `,
  [SavedViewFragment],
);

export const CreateFeedSavedViewMutation = graphql(
  `
    mutation createFeedSavedView($input: FeedSavedViewInput!) {
      createFeedSavedView(input: $input) {
        __typename
        ... on FeedSavedViewType {
          ...SavedViewFragment
        }
        ... on OperationInfo {
          messages {
            kind
            field
            message
          }
        }
      }
    }
  `,
  [SavedViewFragment],
);

export const UpdateFeedSavedViewMutation = graphql(
  `
    mutation updateFeedSavedView($input: FeedSavedViewUpdateInput!) {
      updateFeedSavedView(input: $input) {
        __typename
        ... on FeedSavedViewType {
          ...SavedViewFragment
        }
        ... on OperationInfo {
          messages {
            kind
            field
            message
          }
        }
      }
    }
  `,
  [SavedViewFragment],
);

export const DeleteFeedSavedViewMutation = graphql(`
  mutation deleteFeedSavedView($input: DeleteFeedSavedViewInput!) {
    deleteFeedSavedView(input: $input) {
      __typename
      ... on SuccessResponse {
        message
      }
      ... on OperationInfo {
        messages {
          kind
          field
          message
        }
      }
    }
  }
`);

/**
 * Fetches saved views for a specific feed with minimal fields for dropdown/selector components.
 * Only returns `id` and `name` to reduce payload size.
 *
 * @param feedId - The ID of the feed to fetch saved views for
 */
export const GetSavedViewsList = graphql(`
  query getSavedViewsList($feedId: ID!) {
    feedSavedViews(filters: { feedId: $feedId }) {
      id
      name
    }
  }
`);

export const ToggleSavedViewUserStar = graphql(
  `
    mutation toggleSavedViewUserStar($input: ToggleSavedViewUserStarInput!) {
      toggleSavedViewUserStar(input: $input) {
        __typename
        ... on FeedSavedViewType {
          ...SavedViewFragment
        }
        ... on OperationInfo {
          messages {
            kind
            field
            message
          }
        }
      }
    }
  `,
  [SavedViewFragment],
);

/** @lintignore */
export type SavedViewListItem = ResultOf<
  typeof GetSavedViewsList
>["feedSavedViews"][0];
export type SavedViewItem = ResultOf<typeof GetSavedViews>["feedSavedViews"][0];
